import { useState, useMemo } from 'react'
import { PlatformDevice } from '@/models/platformDevice'
import { PlatformDeviceFilters } from '@/components/PlatformDeviceFilters'

export function usePlatformDeviceFilters(devices: PlatformDevice[]) {
  const [filters, setFilters] = useState<PlatformDeviceFilters>({
    serialNumber: '',
    imei: '',
    phoneNumber: '',
    simSerialNumber: '',
    type: [],
    configurationStatus: [],
    firmwareStatus: [],
    dateAddedFrom: '',
    dateAddedTo: ''
  })

  const handleFilterChange = (key: keyof PlatformDeviceFilters, value: string | string[]) => {
    setFilters(prev => ({ ...prev, [key]: value }))
  }

  const clearAllFilters = () => {
    setFilters({
      serialNumber: '',
      imei: '',
      phoneNumber: '',
      simSerialNumber: '',
      type: [],
      configurationStatus: [],
      firmwareStatus: [],
      dateAddedFrom: '',
      dateAddedTo: ''
    })
  }

  const filteredDevices = useMemo(() => {
    const matchesAnyTerm = (deviceValue: string | undefined | null, filterValue: string): boolean => {
      if (!deviceValue) return false
      const searchTerms = filterValue.split(',').map(term => term.trim().toLowerCase()).filter(term => term.length > 0)
      return searchTerms.some(term => deviceValue.toLowerCase().includes(term))
    }

    return devices.filter(device => {

      if (filters.serialNumber && !matchesAnyTerm(device.serialNumber, filters.serialNumber)) return false
      if (filters.imei && !matchesAnyTerm(device.imei, filters.imei)) return false
      if (filters.phoneNumber && !matchesAnyTerm(device.phoneNumber, filters.phoneNumber)) return false
      if (filters.simSerialNumber && !matchesAnyTerm(device.simSerialNumber, filters.simSerialNumber)) return false

      if (filters.type.length > 0 && !filters.type.includes(device.type || '')) return false
      if (filters.configurationStatus.length > 0 && !filters.configurationStatus.includes(device.configurationStatus || '')) return false
      if (filters.firmwareStatus.length > 0 && !filters.firmwareStatus.includes(device.firmwareStatus || '')) return false

      // Date filters
      if (filters.dateAddedFrom) {
        const deviceDate = new Date(device.dateAddedUtc)
        const fromDate = new Date(filters.dateAddedFrom)
        if (deviceDate < fromDate) return false
      }
      if (filters.dateAddedTo) {
        const deviceDate = new Date(device.dateAddedUtc)
        const toDate = new Date(filters.dateAddedTo)
        toDate.setHours(23, 59, 59, 999) // Include full day
        if (deviceDate > toDate) return false
      }

      return true
    })
  }, [devices, filters])

  return {
    filters,
    filteredDevices,
    handleFilterChange,
    clearAllFilters
  }
}